<template>
  <div class="import-show-page">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Importação">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'imports.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <div v-if="!isLoading" class="container">
        <h1>Detalhes</h1>
        <div class="row">
          <div class="col-3">
            <div class="row">
              <strong>Orígem</strong>
            </div>
            <div class="row">
              <span>{{ this.import.origin }}</span>
            </div>
          </div>

          <div class="col-3">
            <div class="row">
              <strong>Rede</strong>
            </div>
            <div class="row">
              <span>{{ this.import.network.name }}</span>
            </div>
          </div>

          <div class="col-3">
            <div class="row">
              <strong>Data</strong>
            </div>
            <div class="row">
              <span>
                {{ this.import.datetime | date('DD/MM/YYYY [às] HH:mm') }}
              </span>
            </div>
          </div>

          <div class="col-3">
            <div class="row">
              <strong>Finalizado Em:</strong>
            </div>
            <div class="row">
              <span v-if="this.import.ended_at">
                {{ this.import.ended_at | date('DD/MM/YYYY [às] HH:mm') }}
              </span>
              <span v-else>-</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div v-if="result" class="result-container">
            <div
              v-for="(key, index) in Object.keys(attributes)"
              :key="`attr-${index}`"
            >
              <p>
                <strong>{{ attributes[key] }}: </strong>
                <span>{{ result[key] }}</span>
              </p>
            </div>
          </div>
        </div>

        <h1 class="mt-2 mb-2">Vendas importadas</h1>
        <sales-table :importId="this.import.id"></sales-table>
      </div>
    </app-card>
  </div>
</template>

<script>
import ImportService from '@/services/import.service';
import SalesTable from '@/components/Tables/SalesTable.vue';
import ToastMixin from '@/mixins/ToastifyMixin';

import { RESULT_KEYS } from '@/constants/import.constants';

export default {
  name: 'import-show-page',
  components: {
    SalesTable,
  },
  mixins: [ToastMixin],
  data: () => {
    return {
      isLoading: true,
      import: {},
      result: null,
      attributes: RESULT_KEYS,
    };
  },
  methods: {
    loadImport() {
      this.loading = true;
      ImportService.getId(this.$route.params.id)
        .then(({ data }) => {
          this.import = data;
          this.parseResult(data.result);
        })
        .catch(() => this.toastify('Erro ao carregar Carga.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    parseResult(result) {
      try {
        const data = JSON.parse(result);
        if (
          typeof data === 'object' &&
          Object.keys(data).indexOf('sales_exists') !== -1
        ) {
          this.result = data;
        }
      } catch (e) {
        this.result = null;
      }
    },
  },
  beforeMount() {
    this.loadImport();
  },
};
</script>

<style lang="scss" scoped>
.field {
  margin-bottom: 1em;
}

.result-container {
  display: flex;
  flex-wrap: wrap;
  margin: 16px 0;

  > div {
    flex: 0 0 33%;
  }
}

h1 {
  text-align: center;
  font-weight: bold;
  font-size: 1.5em;
}
</style>
